/*
    This file contains all the URLS belong to Release Notes Management menu
*/

// Menu keys
import { MENU_KEYS } from "@Vytelle/admin/src/constants/ApplicationMenuConstants";

const KEY = MENU_KEYS.RELEASE_NOTES;

export const RELEASE_NOTE_PARAMS = {
  RELEASE_NOTE_ID: ":releaseNoteId",
};

export const RELEASE_NOTES_URLS = {
  RELEASE_NOTES_LIST: KEY + "/list",
  RELEASE_NOTES_CREATE: KEY + "/add",
  RELEASE_NOTES_UPDATE: KEY + `/edit/${RELEASE_NOTE_PARAMS.RELEASE_NOTE_ID}`,
  RELEASE_NOTE_DETAIL: KEY + `/details/${RELEASE_NOTE_PARAMS.RELEASE_NOTE_ID}`,
};
